/* eslint-disable no-self-assign */
import {createSlice} from "@reduxjs/toolkit";

const initialRewardItemsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  rewardItemForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const rewardItemsSlice = createSlice({
  name: "rewardItems",
  initialState: initialRewardItemsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {


      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getRewardItemById
    rewardItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.rewardItemForEdit = action.payload.rewardItemForEdit;
      state.error = null;
    },
    // getRewardItemDetailsById
    rewardItemDetailsFetched: (state, action) => {
      state.actionsLoading = false;
      state.rewardItemDetails = action.payload.rewardItemDetails;
      state.error = null;
    },
    // findRewardItems
    rewardItemsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createRewardItem
    rewardItemCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    // updateRewardItem
    rewardItemUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity._id === action.payload.rewardItem._id) {
          return action.payload.rewardItem;
        }
        return entity;
      });
    },
    // deleteRewardItem
    rewardItemDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities;
    },
    // deleteRewardItems
    rewardItemsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // rewardItemsUpdateState
    rewardItemsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity._id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
